<template lang="html">
  <div class="stitched-outfits-container">
    <h1 class="page-title">Stitched Outfits</h1>

    <hr class="mb-5" v-if="!loadingData" />

    <UnstitchOutfitModal />

    <div class="text-center" v-if="loadingData">
      <b-spinner variant="accent" label="Text Centered"></b-spinner>
    </div>

    <div v-else-if="currentUserAllOutfits.length > 0" class="group-items pt-1">
      <div
        v-for="outfit in currentUserAllOutfits"
        :key="outfit.id"
        class="outfit-row"
      >
        <b-row>
          <b-col cols="12" class="d-flex justify-content-between">
            <div class="outfit-title pb-1 pl-2">{{ outfit.title }}</div>
            <Actions :outfit="outfit" />
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <div class="outfit-container">
              <OutfitContent :outfit="outfit" />
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <div v-else>
      <OutfitsEmptyStateContent />
    </div>
  </div>
</template>

<script>
import Actions from "@/components/stitchedOutfits/Actions";
import OutfitContent from "@/components/stitchedOutfits/OutfitContent";
import OutfitsEmptyStateContent from "@/components/stitchedOutfits/OutfitsEmptyStateContent";
import UnstitchOutfitModal from "@/components/stitchedOutfits/UnstitchOutfitModal";

import { mapActions, mapGetters } from "vuex";

export default {
  mounted() {
    window.analytics.page("StitchedOutfits");

    this.fetchCurrentUserOutfits(this.currentUser.id).then((response) => {
      this.loadingData = false;
    });
  },

  data() {
    return {
      loadingData: true,
    };
  },

  components: {
    Actions,
    OutfitContent,
    OutfitsEmptyStateContent,
    UnstitchOutfitModal,
  },

  computed: {
    ...mapGetters(["currentUser", "currentUserAllOutfits"]),
  },

  methods: {
    ...mapActions(["fetchCurrentUserOutfits"]),

    sortProducts(outfit, includesList) {
      const _ = this.$lodash;

      const productObjs = _.filter(outfit.products, function (product) {
        return _.includes(includesList, product.group);
      });

      return _.sortBy(productObjs, "sequence");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.outfit-row {
  margin-bottom: 75px;

  .outfit-title {
    font-size: 20px;
    line-height: 32px;
    color: $grey1;
  }
}

.stitched-outfits-container /deep/ {
  .outfit-container {
    padding: 15px 30px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background: $grey8;
    border: 1px solid $grey5;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

    .carousel-caption {
      bottom: -10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Users/StitchedOutfits.vue